
export const h = {
    case: {
        title: '案例信息设置',
        name: '名称',
        coverImage: '封面图',
        describe: '描述',
        uploadDesc: '点击上传图片,建议尺寸为(500*375)',
        shareLink: '分享链接设置',
        expiration: '永不过期',
        on: '开',
        off: '关',
        failureTime: '失效时间',
        pickDay: '请选择日期',
        pickerOptions: {
            shortcuts: [
                {
                    text: '一天后',
                    value () {
                        const date = new Date();
                        date.setTime(date.getTime() + 3600 * 1000 * 24);
                        return date;
                    }
                },
                {
                    text: '一周后',
                    value () {
                        const date = new Date();
                        date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
                        return date;
                    }
                },
                {
                    text: '30天后',
                    value () {
                        const date = new Date();
                        date.setTime(date.getTime() + 3600 * 1000 * 24 * 30);
                        return date;
                    }
                }
            ]
        },
        dateCannotEmpty: '日期不能为空',
        nameCannotEmpty: '名称不能为空!',
        descCannotEmpty: '描述不能为空!',
        logoSet: 'logo 设置',
        selectAll: '全选',
        noBrand: '暂无品牌',
        openEffect: '开场效果',
        closeOpenMode: '无',
        asteroidOpen: '小行星开场',
        horizontalOpen: '水平巡游开场',
        asteroidCruise: '小行星巡游开场',
        Crystal: '水晶球开场',
        asteroidScale: '小行星缩放开场',
        limitImage: '图片尺寸过大，请限制图片大小不超过4M',
        imageType: '图片类型错误，请上传png、jpg格式的图片',


    },
    slide: {
        case: '案例',
        save: '保存',
        view: '查看',
        panorama: '全景',
        angleView: '视角',
        hotspot: '热点',
        music: '音乐',
        designer: '设计师',
        beautify: '美化',
    },
    list: {
        title: '全景列表设置',
        draganoramicsort: '拖动全景排序',
        resetSort: '重置排序',
        addPanoramic: '新增全景',
        customThumbnailImages: '自定义缩略图',
        more: '更多',
        downloadImage: '下载全景图片',
        replaceImage: '替换全景图片',
        downloadImagePackage: '下载全景图包',
        downloadDiagram: '下载通道图',
        ApplyThumbnailToImage: '将此缩略图应用到案例封面图',
        VoiceBroadcast: '语音播报信息',
        restoreImage: '还原全景图片',
        uploadImage: '点击上传图片',
        upgradePackage: '升级套餐',
        eidt: '全景修改',
        name: '全景名称',
        thumbnail: '缩略图',
        enterName: '输入全景名称',
        uploadDesc: '点击上传图片,建议尺寸为(500*375)',
        confirm: '确定',
        cannotEmpty: '全景名称不能为空',
        selectToAdd: '选择全景新增',
        selectAll: '全选本页',
        StartAndEnd: '起止时间',
        schemeName: '渲染方案名称',
        searchThisPlan: '按本方案查询',
        search: '查询',
        empty: '当前时间段内，没有渲染的场景',
        dateOptions: {
            shortcuts: [
              {
                text: "今天",
                value() {
                  const end = new Date(
                    new Date(new Date().toLocaleDateString()).getTime() +
                      24 * 60 * 60 * 1000 -
                      1
                  );
                  const start = new Date(
                    new Date(new Date().toLocaleDateString()).getTime()
                  );
                  return [start, end];
                },
              },
              {
                text: "3天前",
                value() {
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 3);
                  return [start, end];
                },
              },
              {
                text: "1周前",
                value() {
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                  return [start, end];
                },
              },
              {
                text: "30天前",
                value() {
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                  return [start, end];
                },
              },
              {
                text: "90天前",
                value() {
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                  return [start, end];
                },
              },
            ],
        },
        loading: '加载中...',
        sceneAlreadyExists: '当前全景列表已存在此场景',
        previewImage: '当前全景为快速预览图',
        applyToThumbnail: '应用到缩略图',
        delete: '删除',
        content: '删除该场景，会删除其它场景中指向该场景的热点，是否继续删除？',
        captureScreen: '截取屏幕中',
        generateScreenshots: '生成屏幕截图',
        thumbnailApply: '应用缩略图成功，保存后生效',
        atLeastOne: '请至少保留一个场景~',
        downloadCompleted: '下载完成!',
        fielDownloadFailed: '文件下载失败!',
        limitImageSize: '图片尺寸过大，请限制图片大小不超过',
        imageType: '图片类型错误，请上传png、jpg格式的图片',
        imageAspectRatio: '请上传宽高比为',
        replaceFailed: '替换失败,请重试',
        uploadFailed: '上传失败,请重试',
        restoreFailed: '还原失败',
        applySuccess: '应用成功，保存后生效',
        dateCannotEmpty: '日期不能为空',
    },
    camera: {
        rotationSettings: '旋转设置',
        turnOnRotation: '开启旋转',
        waitTime: '等待时间(秒)',
        clickSettings: '一键设置',
        rotationInfoBefore: '您确认将当前旋转状态应用到当前场景列表的',
        rotationInfoAfter: '个场景，并保存吗？',
        cameraSettings: '镜头设置',
        recently: '最近：场景缩放时的最小视域',
        initial: '初始：进入场景的初始视域',
        farthest: '最远：场景缩放时的最大视域',
        recommended: '推荐设置：最近70，初始95，最远125',
        viewingAngle: '视角范围',
        recentlyt: '最近',
        initialt: '初始',
        farthestt: '最远',
        viewInfoFirst: '您确认将当前视野范围（最近：',
        viewInfoSecend: '）应用到当前场景列表的',
        viewInfoThird: '个场景，并保存吗？',
        inCommonUse: '设为常用',
        cameraSettings: '镜头设置',
        reset: '重置',
        stapleInfo: '将当前视角范围保存为我的常用镜头',
        commonLenses: '常用镜头',
        systemLens: '系统镜头',
        restoreInfo: "恢复当前场景的视野范围初始值",
        restoreDefault: '恢复默认成功',
        recommendedLens: '使用推荐镜头成功，保存后生效',
        usedLenses: '使用常用镜头成功，保存后生效',
        initialViewpoint: '初始视角设置成功，保存后生效',
        setCommonLens: '设置常用镜头成功',
        initialPerspective: '设为初始视角',
    },
    hotspot: {
        addHotspots: '新增热点',
        clear: '清空',
        clearHotspots: '清空热点',
        clearHotspotsForCurrentScene: '清空当前场景热点列表',
        editHotspots: '编辑热点',
        return: '返回',
        hotspotType: '热点类型',
        type: '类型',
        hotspotList: '当前场景热点列表',
        all: '全部',
        navigation: '导航',
        link: '超链接',
        image: '图片',
        deleteHotspot: '确认删除此热点',
        style: '样式',
        hotspotName: '热点名称',
        name: '名称',
        enterHotspotName: '请输入热点名称',
        targetPanorama: '目标全景',
        ok: '确认',
        cancel: '取消',
        edit: '修改',
        delete: '删除',
        confirmDelete: '确认删除此热点',
        hotspotImage: '热点图片',
        uploadImage: '点击上传图片',
        editImage: '修改图片',
        addImage: '添加图片',
        hotspotAddress: '热点地址',
        address: '地址',
        targetUrl: '请输入目标URL',
        videoAddress: '视频地址',
        videoUrl: '请输入视频URL',
        targetNoEmpty: '目标场景不能为空',
        noTarget: '暂无目标场景',
        hotspotNameNoEmpty: '热点名称不能为空',
        hotspotDetailNoEmpty: '热点详情不能为空',
        linkNoEmpty: '链接地址不能为空',
        linkIncorrect: '链接地址格式不正确',
        videoNoEmpty: '视频链接地址不能为空',
        pleaseUploadImage: '请先上传热点图片',
        limitImage: '图片尺寸过大，请限制图片大小不超过30M',
        uploadFailed: '上传失败,请重试',
        uploadSuccessful: '上传成功',
        imageType: '图片类型错误，请上传png、jpg格式的图片',
        text: '文本',
        video: '视频',
        hotspotDetail: '热点详情',
        detail: '详情',
        noOtherScene: '暂无其他场景',
        enterHotspotDetail: '请输入热点详情',
        videoResources: '视频资源',
        clickToSwitch: '点击切换',
        clickUploadVideo: '点击上传视频',
        videoFormat: '支持MP4格式，最大不超过100M',
        enerVideoUrl: '请输入视频URL',
    },
    music: {
        musicSettings: '音乐设置',
        trialListening: '试听',
        stopListening: '停止试听',
        setMusic: '设置音乐',
        backgroundMusic: '背景音乐',
        SystemMusicLibrary: '系统曲库',
        selected: '已选择',
        myMusic: '我的音乐',
        uploadMusic: '上传音乐',
        upgradePackage: '升级套餐',
        uploadAgree: '上传即同意',
        disclaimer: '请先勾选免责声明',
        musicName: '请输入音乐名称',
        deleteMusic: '删除音乐',
        noCustomMusic: '暂无自定义音乐',
        onlineMusic: '线上音乐',
        operationProcess: '操作流程',
        oneStep: '找到正确的音频链接，在浏览器输入栏中输入音频链接，若可以播放或下载，一般就是正确的音频链接；',
        twoStep: '将音频链接粘贴到上方输入栏中；',
        threeStep: '先点击确定按钮,再点击左上角保存即可。',
        ok: '确 定',
        placeholderInfo: '输入网上音乐地址，并保证音乐可用性',
        musicAddress: '请输入音乐地址',
        limitMusic: '音乐地址过长,请限制地址长度不超过150字符',
        saveMusic: '请先选择音乐再保存',
        linkIncorrect: '链接地址格式不正确',
        musicNonEmpty: '音乐名称不能为空',
        eidtFailed: '修改失败',
        deleteSuccess: '删除成功',
        deleteFailed: '删除失败',
        limitNameCharacter: '文件名称超过50字符,请修改后再上传',
        limitFileSize: '文件过大,请限制文件不超过10M',
        limitFileType: '文件格式错误,请上传mp3或wav格式文件',
        limitFileNumber: '文件过多,最多限制上传30个文件',
        uploadFailed: '上传失败,请重试',
        uploadSuccessful: '上传成功',
        disclaimerInfo: '免责声明',
    },
    design: {
        designerInfo: '设计师信息设置',
        name: '姓名',
        enterName: '输入名称',
        phone: '电话',
        enterPhone: '输入电话',
        avater: '头像',
        uploadImageInfo: '点击上传图片,建议尺寸为(64*64)',
        nameNonEmpty: '姓名不能为空！',
        phoneNonEmpty: '电话不能为空！',
        phoneNumber: '请输入正确的电话号码！',
        limitImage: '图片尺寸过大，请限制图片大小不超过4M',
        imageType: '图片类型错误，请上传png、jpg格式的图片',
    },
    beauty: {
        filterSet: '滤镜设置',
        colorSet: '色彩设置',
        brightness: '亮度',
        contrastRatio: '对比度',
        saturation: '饱和度',
        hue: '色相',
        restoreDefault: '恢复默认',
        compareOriginalImage: '对比原图',
        originalImage: '按住显示原图',
        noFilter: '无滤镜',
        warmYellow: '温馨黄',
        romanticPurple: '浪漫紫',
        modernGrey: '摩登灰',
        restoreSuccessful: '恢复默认成功',
    },
    tipInfo: {
        tip: '提示',
        switchNavigation: '切换导航',
        save: '保存',
        fillCorrectly: '请正确填写后',
        panoramaEditor: '全景编辑器',
        editSave: '请编辑后保存',
        viewSave: '您还有未保存的信息，请先操作保存之后进行查看',
        saveView: '保存查看',
        save: '保存中',
        saveSuccess: '保存成功'
    },
    loading: {
      schemeLoading: '方案加载中...',
      loadingTitle: '致力做最好的一体化家居设计平台',
      loadingStrives: '天工智家倾力打造',
    },
    driver: {
      案例详情: '案例详情',
      修改全景名称描述等: '修改全景名称、描述等，设置全景过期时间，控制品牌logo的显示等。',
      下一步: '下一步',
      上一步: '上一步',
      关闭: '关闭',
      完成: '完成',
      全景列表: '全景列表',
      增加删除修改场景: '增加、删除、修改场景，下载全景图片，替换全景缩略图，修改全景名称等。',
      视角设置: '视角设置',
      设置全景是否开启自动旋转: '设置全景是否开启自动旋转；全景的初始视角信息等。',
      热点设置: '热点设置',
      增加新的热点或修改已有热点: '增加新的热点或修改已有热点。',
      设置音乐: '设置音乐',
      设计师信息设置: '设计师信息设置',
      设置设计师头像姓名: '设置设计师头像，姓名，联系方式等信息。',
      美化设置: '美化设置',
      设置全景滤镜效果: '设置全景滤镜效果；修改全景色彩亮度、对比度、色相等。'
    },
    video: {
      视频转换: '视频转换',
      上传视频: '上传视频',
      视频格式错误请重新上传视频将转码转码时无法使用全景其他功能: '视频格式错误，请重新上传。视频将转码，转码时无法使用全景其他功能。',
      支持MP4格式最大不超过300M: '支持MP4格式，最大不超过300M',
      上传视频编码错误请重新上传: '上传视频编码错误，请重新上传',
      视频转换中: '视频转换中'
    }
  }



// WEBPACK FOOTER //
// ./src/i18n/lan/zh.js